import { Modal } from 'reactstrap'
import './style.scss'

export default function ModalInfoSubItem({ isOpen, toggle, row }) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-sub-item-custom" centered>
      <div className="prod-modal-hd">
        <span className="prod-modal-title">Sub-Items ({row?.name})</span>
        <button type="button" className="prod-modal-close" onClick={toggle}>
          ×
        </button>
      </div>

      <div className="prod-modal-body">
        {row?.subItems && row.subItems.length > 0 ? (
          row.subItems.map((group, index) => (
            <div key={group.id || index} className="sub-item-group">
              <div className="sub-item-group-header">
                <span className="sub-item-type">{group.type || `Group ${index + 1}`}</span>
                {group.required === 1 ? (
                  <span className="badge-status required">Required</span>
                ) : (
                  <span className="badge-status optional">Optional</span>
                )}
              </div>

              {group.list && group.list.length > 0 && (
                <ul className="sub-item-options-list">
                  {group.list.map((option, optIdx) => (
                    <li key={option.id || optIdx} className="sub-item-option-item">
                      <span className="option-name">{option.name}</span>
                      <span className="option-price">
                        {option.price !== undefined && option.price !== null
                          ? `$${Number(option.price).toFixed(2)}`
                          : ''}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))
        ) : (
          <div className="text-center text-muted py-3">No sub-items available</div>
        )}
      </div>

      <div className="modal-footer">
        <button type="button" className="btn-close-modal" onClick={toggle}>
          Close
        </button>
      </div>
    </Modal>
  )
}
